import { IndexBloc } from "./IndexBloc";
import styles from "./Index.module.scss";
import { get, isEmpty, map } from "lodash";
import ImageLoading from "../../../../../../views/components/ImageLoading/ImageLoading";
import { useDidMount } from "imagica-uikit/dist/hooks/useDidMount";

type ImgProps = {
  placeId: string;
};

export function MapImg(props: ImgProps) {
  const bloc = new IndexBloc();

  useDidMount(() => {
    if (isEmpty(props.placeId)) {
      return;
    }
    bloc.initImg(props.placeId);
  });

  return (
    <div className={styles.MapImgLIst}>
      {map(bloc.photoList.value, (item: string, index: number) => (
        <div key={item + index} className={styles.ImgItem}>
          <ImageLoading loading={item === "pending"} showLabel={false} style={{ width: "80px", height: "80px" }} />
          {item !== "pending" && <img src={item} alt="" />}
        </div>
      ))}
    </div>
  );
}
